import "./PlusIcon.scss"

export const PlusIcon = ({ color, marginToTop }) => (
  <span className={`PlusIcon PlusIcon__color-${color} PlusIcon__margin-top-${marginToTop}`}>+</span>
);
